import type {ComponentPropsWithRef} from 'react';
import React, {Children} from 'react';
import {hashedClasses} from '@pb/kit-util-with-css-module';

import styles from './table.module.styl';

const classes = hashedClasses(styles);

export type SubtitleProps = ComponentPropsWithRef<'div'>;

/**
 * @deprecated This component will be removed in 6 months 03-03-2026.
 * Create custom layouts on the consumer side instead.
 */
export const Subtitle = ({children, ref, ...rest}: SubtitleProps) => {
    if (!Children.count(children)) {
        return null;
    }
    return (
        <div {...rest} ref={ref} className={classes.table__subtitle}>
            {children}
        </div>
    );
};
